import axios from "axios";
import { CreateTransferParams } from "./types";

export const createTransferId = async (params: CreateTransferParams) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/transferId/create`,
      {
        transferid_number: params.number,
        transferid_name: params.name,
        transferid_description: params.description,
        deliverables: params.deliverables,
        transferid_createdby: params.createdBy,
      },
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    if (error.status === 409) {
      return error.status;
    }
    return null;
  }
};
